const dotNotationToObject = (key, value) => {
  let object = {};
  const result = object;
  const arr = key.split(".");
  for (let i = 0; i < arr.length - 1; i++) {
    object[arr[i]] = {};
    object = object[arr[i]];
  }
  object[arr[arr.length - 1]] = value;
  return result;
};
const mergeObject = (targetObject = {}, sourceObject = {}) => {
  const copyTargetObject = JSON.parse(JSON.stringify(targetObject));
  const copySourceObject = JSON.parse(JSON.stringify(sourceObject));
  Object.keys(copySourceObject).forEach((key) => {
    if (typeof copySourceObject[key] === "object" && !Array.isArray(copySourceObject[key]) && copySourceObject[key] !== null) {
      copyTargetObject[key] = mergeObject(copyTargetObject[key], copySourceObject[key]);
    } else {
      copyTargetObject[key] = copySourceObject[key];
    }
  });
  return copyTargetObject;
};
function parseChangeSet(changeSet) {
  let object = {};
  Object.keys(changeSet).forEach((operation) => {
    const data = changeSet[operation];
    Object.keys(data).forEach((key) => {
      const value = data[key];
      object = mergeObject(object, dotNotationToObject(key, value));
    });
  });
  return object;
}

export { parseChangeSet as p };
//# sourceMappingURL=parseChangeSet-03074a6b.js.map
